import Api, { ErrorMode, FetchMethodType } from './Api';

export interface RequestShiftPayload {
  shiftRequirementId: number;
}

export interface AvailableShiftModel {
  shiftId: number;
  shiftRequirementId: number;
  userShiftId: number | null;
  shiftTypeId: number;
  shiftType: string;
  positionId: number;
  position: string;
  shiftStartDate: string;
  shiftEndDate: string;
  shiftBeginTime: string;
  shiftEndTime: string;
  shiftRequirementFilled: boolean;
  locationId: number;
  locationName: string;
  departmentId: number;
  departmentName: string;
  staffRequired: number;
  staffHired: number;
  isUsedForOpenShifts: boolean;
  showOpenShifts: boolean;
  teamName: string;
  goalAcceleration: string;
  amount: number | null;
}

export type GetAvailableShiftsResponse = AvailableShiftModel[];

export interface ShiftWizardApi {
  getAvailableShifts(appId: string): Promise<GetAvailableShiftsResponse>;
  requestShift(appId: string, payload: RequestShiftPayload): Promise<void>;
}

export default class ShiftWizardRestApi extends Api implements ShiftWizardApi {
  async getAvailableShifts(appId: string): Promise<GetAvailableShiftsResponse> {
    return this.fetch<GetAvailableShiftsResponse>(`/scheduling/upcomingOpenShifts/${appId}`, {
      method: FetchMethodType.GET,
    });
  }

  async requestShift(appId: string, payload: RequestShiftPayload): Promise<void> {
    await this.fetch<void>(`/scheduling/requestUserShift/${appId}`, {
      method: FetchMethodType.POST,
      body: payload,
      errorMode: ErrorMode.HideError,
    });
  }
}
